import Index from '../views/Despacho/Index'
import Detail from '../views/Despacho/Detail'
import TeamPanel from '../views/Despacho/TeamPanel'

let routes = {
    path: '/despacho',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/despacho',
            name: 'despacho',
            component: Index,
            meta: {
                pageTitle: 'despacho.title',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'despacho.title',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/despacho/painel-equipes',
            name: 'despacho-team-panel',
            component: TeamPanel,
            meta: {
                pageTitle: 'despacho.teamPanelTitle',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'despacho.title',
                        to: '/despacho',
                    },
                    {
                        text: 'despacho.teamPanelTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/despacho/:id',
            name: 'despacho-detail',
            component: Detail,
            meta: {
                pageTitle: 'despacho.title',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'despacho.title',
                        to: '/despacho',
                    },
                    {
                        text: 'despacho.breadcrumbDetail',
                        active: true,
                    },
                ],
            },
        },
    ],
}

export default routes
